import { Skeleton } from '@mui/material';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from '@Components/DomElements/Select';
import SelectOption from '@Components/DomElements/SelectOption';
import OrganizationsApi from '@Data/organizations/Api';
import { IOrganization } from '@Data/organizations/Interfaces';
import {
    activeOrganizationsState,
    organizationsState,
    selectedOrganizationState,
} from '@Data/organizations/Reducer';
import TeamsApi from '@Data/teams/Api';
import { KoruRoutes } from '@Services/navigation/Paths';

const OrganizationSelector = () => {
    const navigate = useNavigate();
    const selectRef = useRef();
    const orgs = useSelector(activeOrganizationsState);
    const selectedOrg = useSelector(selectedOrganizationState);
    const selectedOrgName = _isNil(selectedOrg)
        ? ''
        : selectedOrg.organisation_name;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (_isNil(orgs)) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, [orgs]);

    const handleSelectOrganization = (org: IOrganization) => {
        TeamsApi.clearTeams();
        OrganizationsApi.setSelectedOrganization(org);
        const url = KoruRoutes.root.getUrl(org.organisation_id);
        navigate(url);
    };

    const options =
        orgs && !isLoading
            ? orgs.map((org, index) => {
                  return (
                      <SelectOption
                          id={`organization-option-${org.organisation_id}`}
                          key={`orgOpt${org.organisation_id}`}
                          parentRef={selectRef}
                          text={org.organisation_name}
                          onClick={() => handleSelectOrganization(org)}
                      />
                  );
              })
            : null;

    const innerHtml = isLoading ? (
        <Skeleton width={165} height={28} />
    ) : (
        <Select
            id="organization-selector"
            ref={selectRef}
            value={selectedOrgName}
            disabled={isLoading}
        >
            {options}
        </Select>
    );

    return <React.Fragment>{innerHtml}</React.Fragment>;
};

export default OrganizationSelector;
